import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import { CLASS_FIELDS } from "./source-fields";

export const classSources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.CLASS_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLASS,
                fields: CLASS_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_CREATE_CLASS],
        enabled: true,
    },
    {
        sourceType: APIProcessName.CLASS_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLASS,
                fields: CLASS_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: [APIProcessName.PLATFORM_UPDATE_CLASS],
        enabled: true,
    },
    {
        sourceType: APIProcessName.CLASS_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLASS,
                fields: CLASS_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: [APIProcessName.PLATFORM_DELETE_CLASS],
        enabled: true,
    },
    {
        sourceType: APIProcessName.CLASS_CHANGE_POSITION,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLASS,
                fields: CLASS_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
];
